import { useEffect, useRef, useState } from 'react';

import ReactMarkdown from 'react-markdown';

import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { Box, Card, Dialog, Stack } from '@mui/material';

import TitleFormComponent from '../TitleForm';
import * as S from './styles';
import Button from 'components/Button';
import Text from 'components/Text';
import { useThemeContext } from 'global/ThemeContext/ThemeContext';

interface ITermComponent {
  title?: string;
  subtitle?: string;
  description?: string;
  content?: string;
  version?: string;
}

const TermComponent = ({
  title = '',
  subtitle = '',
  description = '',
  content = '',
  version = 'v.1.0',
}: ITermComponent) => {
  const theme = useThemeContext();
  const [viewModal, setViewModal] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [acceptedDate, setAcceptedDate] = useState<string | null>(null);
  const [primaryButtonDisabled, setPrimaryButtonDisabled] = useState(true);
  const contentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const storedAccepted = localStorage.getItem('termAccepted');
    const storedDate = localStorage.getItem('acceptedDate');
    if (storedAccepted === 'true' && storedDate) {
      setAccepted(true);
      setAcceptedDate(storedDate);
    }
  }, []);

  const handleOpenModal = () => {
    setViewModal(true);
  };

  const handleCloseModal = () => {
    setViewModal(false);
  };

  const handleAccept = () => {
    const currentDate = new Date().toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });

    localStorage.setItem('termAccepted', 'true');
    localStorage.setItem('acceptedDate', currentDate);

    setAccepted(true);
    setAcceptedDate(currentDate);
    setViewModal(false);
  };

  const handleDecline = () => {
    handleCloseModal();
  };

  const handleScroll = () => {
    if (contentRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
      if (scrollTop + clientHeight >= scrollHeight) {
        setPrimaryButtonDisabled(false);
      }
    }
  };

  return (
    <>
      <Box>
        <TitleFormComponent title={title} />
        <Card>
          <Text color="textPrimary" bold>
            {subtitle}
          </Text>
          <Text color="textPrimary">{description}</Text>

          <Box
            gap={1}
            margin={4}
            sx={{
              display: 'flex',
              direction: 'row',
              alignContent: 'center',
              justifyContent: 'center',
            }}
          >
            {!accepted ? (
              <Button size="large" onClick={handleOpenModal}>
                Abrir Termo ({version})
              </Button>
            ) : (
              <Stack direction="row" alignItems="center" gap={1}>
                <CheckCircleOutlineOutlinedIcon sx={{ color: theme.success }} />
                <Text size="medium" color="textPrimary">
                  Assinado!
                </Text>
                <Text size="small" color="green">
                  ({acceptedDate})
                </Text>
              </Stack>
            )}
          </Box>
        </Card>
      </Box>

      <Dialog maxWidth="xs" open={viewModal} onClose={handleCloseModal}>
        <Text color="textPrimary" bold size="xLarge" textAlign="center">
          {subtitle}
        </Text>
        <S.ScrollableContent onScroll={handleScroll} ref={contentRef}>
          <ReactMarkdown className="content-markdown">{content}</ReactMarkdown>
        </S.ScrollableContent>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '1rem',
            gap: '1rem',
          }}
        >
          <Button onClick={handleDecline} variant="outline" fullWidth>
            Recusar
          </Button>
          <Button
            onClick={handleAccept}
            variant="primary"
            // disabled={primaryButtonDisabled}
            fullWidth
          >
            Aceitar
          </Button>
        </div>
      </Dialog>
    </>
  );
};

export default TermComponent;
